import { EnvironmentBase } from "./environment.base";

export class Environment extends EnvironmentBase {
  constructor() {
    super("config/environment.qa.json");
  }
  public get azureClientId() {
    return process.env.NG_APP_CTT_QA_AZURE_CLIENT_ID || super.azureClientId;
  } 

  public get azureRedirectUri() {
    return (
      super.azureRedirectUri || "https://concierge-transaction-qa.aritzia.com"
    );
  }
}

export const environment = new Environment();
